import React from "react";

const SERVICE_ACCENTS = [
  { glow: "rgba(79,142,247,0.35)", border: "rgba(79,142,247,0.55)", tag: "#4f8ef7" },
  { glow: "rgba(16,217,168,0.35)", border: "rgba(16,217,168,0.55)", tag: "#10d9a8" },
  { glow: "rgba(139,92,246,0.35)", border: "rgba(139,92,246,0.55)", tag: "#8b5cf6" },
  { glow: "rgba(251,146,60,0.35)", border: "rgba(251,146,60,0.55)", tag: "#fb923c" },
];

export default function Services({ t }) {
  const services = [
    {
      title: t.service1_title,
      desc: t.service1_desc,
      usecase: t.service1_usecase,
      icon: "🌐",
    },
    {
      title: t.service2_title,
      desc: t.service2_desc,
      usecase: t.service2_usecase,
      icon: "📱",
    },
    {
      title: t.service3_title,
      desc: t.service3_desc,
      usecase: t.service3_usecase,
      icon: "⚡",
    },
    {
      title: t.service4_title,
      desc: t.service4_desc,
      usecase: t.service4_usecase,
      icon: "🤖",
    }
  ];

  return (
    <section
      id="services"
      aria-labelledby="services-heading"
      style={{
        padding: "6rem 2rem",
        background: "var(--bg-secondary)",
        position: "relative",
        overflow: "hidden"
      }}
    >
      {/* Background glow */}
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        width: "600px", height: "400px",
        background: "radial-gradient(ellipse, rgba(139,92,246,0.08) 0%, transparent 70%)",
        pointerEvents: "none"
      }} />

      <div style={{ maxWidth: "1100px", margin: "0 auto", position: "relative" }}>
        {/* Section label */}
        <p style={{
          textAlign: "center",
          fontSize: "0.75rem",
          fontWeight: "600",
          letterSpacing: "3px",
          textTransform: "uppercase",
          color: "var(--accent-purple)",
          marginBottom: "0.8rem"
        }}>
          {t.services}
        </p>

        <h2
          id="services-heading"
          style={{
            textAlign: "center",
            fontSize: "2.2rem",
            fontWeight: "800",
            marginBottom: "1rem",
            color: "var(--text-primary)",
            letterSpacing: "-0.03em"
          }}
        >
          {t.services_title}
        </h2>

        <p style={{
          textAlign: "center",
          color: "var(--text-secondary)",
          fontSize: "1rem",
          maxWidth: "560px",
          margin: "0 auto 3.5rem"
        }}>
          {t.services_subtitle || ""}
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "1.5rem"
          }}
        >
          {services.map((srv, i) => {
            const accent = SERVICE_ACCENTS[i];
            return (
              <div
                key={i}
                style={{
                  background: "var(--bg-card)",
                  border: `1px solid ${accent.border}`,
                  borderRadius: "20px",
                  padding: "2rem 1.75rem",
                  boxShadow: `0 4px 32px ${accent.glow}`,
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  transition: "transform 0.25s, box-shadow 0.25s",
                  cursor: "default"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = `0 12px 48px ${accent.glow}`;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = `0 4px 32px ${accent.glow}`;
                }}
              >
                {/* Icon bubble */}
                <div style={{
                  width: "52px", height: "52px",
                  background: `linear-gradient(135deg, ${accent.glow.replace("0.2", "0.15")}, transparent)`,
                  border: `1px solid ${accent.border}`,
                  borderRadius: "14px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "1.6rem"
                }}>
                  {srv.icon}
                </div>

                <h3 style={{
                  margin: 0,
                  fontSize: "1.05rem",
                  fontWeight: "700",
                  color: "var(--text-primary)",
                  letterSpacing: "-0.01em"
                }}>
                  {srv.title}
                </h3>

                <p style={{
                  margin: 0,
                  fontSize: "0.9rem",
                  color: "var(--text-secondary)",
                  lineHeight: "1.6"
                }}>
                  {srv.desc}
                </p>

                {/* Use Case block */}
                <div style={{
                  background: "rgba(0,0,0,0.25)",
                  border: `1px solid ${accent.border}`,
                  borderRadius: "10px",
                  padding: "0.8rem 1rem",
                  marginTop: "auto"
                }}>
                  <span style={{
                    display: "inline-block",
                    fontSize: "0.68rem",
                    fontWeight: "700",
                    letterSpacing: "1.5px",
                    textTransform: "uppercase",
                    color: accent.tag,
                    marginBottom: "0.4rem"
                  }}>
                    Use Case
                  </span>
                  <p style={{
                    margin: 0,
                    fontSize: "0.82rem",
                    color: "rgba(255,255,255,0.55)",
                    lineHeight: "1.55"
                  }}>
                    {srv.usecase}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
